module.exports = __webpack_public_path__ + "static/media/4.2797bbd1.jpg";